<template>
  <component
    :is="MainComponent"
    v-model="isVisible"
    :width="isMobile ? undefined : 360"
    scrollable
  >
    <v-card
      class="text--text"
      :max-height="isMobile ? undefined : 500"
    >
      <div v-if="!isMobile">
        <div class="d-flex align-center pa-4">
          <v-icon
            class="mr-4"
            color="icon-secondary"
            size="24"
            @click="isVisible = false"
          >
            ui-icon-close-not-a-circle
          </v-icon>
          <div class="text-h6 text--text">
            {{ t('Дарим скидку 300 ₽ за честный отзыв', { ns: language }) }}
          </div>
        </div>
        <v-divider />
      </div>
      <div
        v-if="isMobile"
        class="d-flex align-center px-4 pt-6 mb-2"
      >
        <div class="text-h6 text--text">
          {{ t('Дарим скидку 300 ₽ за честный отзыв', { ns: language }) }}
        </div>
      </div>
      <v-card-text
        class="px-0"
        :class="isMobile ? 'py-0' : 'py-4'"
      >
        <div class="text-body-1 text-secondary--text px-4 mb-2">
          {{ t('Важно любое ваше мнение: позитивное или негативное.', { ns: language }) }}
        </div>
        <template v-if="openEventPayload.lpuList">
          <div class="text-subtitle-1 text--text px-4 mt-5 mb-2">
            {{ t('Можно оставить отзыв о приёме в клинике', { ns: language }) }}
          </div>
          <a
            v-for="lpu in openEventPayload.lpuList"
            :key="lpu.doctorPrsLandingUrl"
            v-ripple
            class="d-flex align-center text-decoration-none px-4 py-2"
            :href="lpu.doctorPrsLandingUrl"
          >
            <div class="mr-4">
              <div class="text-body-1">
                {{ lpu.name }}
              </div>
              <div class="text-body-2 text-secondary--text">
                {{ lpu.address }}
              </div>
            </div>
            <v-spacer />
            <v-icon color="icon-secondary">
              ui-icon-arrow-right
            </v-icon>
          </a>
        </template>
      </v-card-text>
      <v-sheet
        class=""
        :class="isMobile ? 'px-4 pb-4 mt-5' : 'pa-2'"
        :elevation="isMobile || !openEventPayload.lpuList ? 0 : 8"
      >
        <v-btn
          class="primary--text"
          color="bg-primary"
          depressed
          block
          @click="handleClickButton"
        >
          {{ t('Хорошо', { ns: language }) }}
        </v-btn>
      </v-sheet>
    </v-card>
  </component>
</template>

<script setup lang="ts">
import { onMounted, ref } from 'vue'
import { VBottomSheet, VDialog } from 'vuetify/lib'
import I18NextVue from 'i18next'

type OpenEventPayload = {
  lpuList: Array<{
    name: string
    address: string
    doctorPrsLandingUrl: string
  }>
}

const { t, language } = I18NextVue

const isMobile = window.MOBILE_VERSION
const MainComponent = isMobile ? VBottomSheet : VDialog

const isVisible = ref(false)
const openEventPayload = ref<OpenEventPayload>({
  lpuList: [],
})

onMounted(() => {
  // eslint-disable-next-line no-undef
  window.addEventListener('review-power-info:open', ({ detail: payload }: CustomEventInit<OpenEventPayload>) => {
    if (payload) {
      isVisible.value = true
      openEventPayload.value = payload
    }
  })
})

function handleClickButton() {
  isVisible.value = false
}
</script>
